import LocationToggle from './LocationToggle';

export default LocationToggle;
